module.exports = __webpack_public_path__ + "img/tutorial_simulated_04.0872df9e.gif";